import React, { useState } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { fetchData } from 'reducers/dataTable';
import { enableEditMode } from 'reducers/barnsheets/barnsheetsGroupCheckups';
// components
import TreatmentsPanel from '../components/TreatmentsPanel';
import TreatmentsHistoryTable from '../components/TreatmentsHistoryTable';
import BarnSheetsTreatmentsProfile from '../components/BarnSheetsTreatmentsProfile';
// utils
import { getFilterOptions, preparePeriodDates, treatmentHistoryOptions } from '../utils/barnSheetsTreatments';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
// styles
import './BarnsheetsFarmTreatmentsHistory.scss';

const BarnSheetsFarmTreatmentsHistory = ({
  currentUser,
  enableEditMode,
  fetchData,
  isLoading,
  location,
  measurementSystem,
  meta,
  params,
  resources,
  reqParams,
  countryCode,
}) => {
  const [{ period_name, date_start, date_end }, setState] = useState(preparePeriodDates('28_days'));
  const { roles_map: { admin } } = currentUser;
  const { farmId } = params;

  const handleChangeDates = ({ startDate, endDate }) => {
    setState((prevState) => ({ ...prevState, date_start: startDate, date_end: endDate }));
  };

  const handleSelectPeriod = (option) => {
    if (!option) return;
    const { value } = option;
    if (value !== period_name) {
      setState(preparePeriodDates(value));
    }
  };

  const filterOptions = getFilterOptions(`/barnsheets/farms/${farmId}/treatments`, admin);

  return (
    <BarnSheetsTreatmentsProfile
      dateEnd={date_end}
      dateStart={date_start}
      filterOptions={filterOptions}
      pathname={location.pathname}
      options={treatmentHistoryOptions}
      onSelectPeriod={handleSelectPeriod}
      onChangeDates={handleChangeDates}
      periodName={period_name}
    >
      <div className="BarnSheetsFarmTreatments">
        <div className="small-12 column">
          <TreatmentsPanel
            dateEnd={date_end}
            dateStart={date_start}
            measurementSystem={measurementSystem}
            path={`/farms/${farmId}/treatment_history`}
            periodName={period_name}
          />
        </div>

        <TreatmentsHistoryTable
          dateEnd={date_end}
          dateStart={date_start}
          enableEditMode={enableEditMode}
          fetchData={fetchData}
          isAdmin={admin}
          isLoading={isLoading}
          measurementSystem={measurementSystem}
          meta={meta}
          reqParams={reqParams}
          resources={resources}
          tableId="barnsheetsFarmTreatments"
          countryCode={countryCode}
        />
      </div>
    </BarnSheetsTreatmentsProfile>
  );
};

BarnSheetsFarmTreatmentsHistory.propTypes = {
  resources: T.array,
  isLoading: T.bool,
  params: T.object,
  location: T.object,
  meta: T.object,
  reqParams: T.object,
  fetchData: T.func.isRequired,
  enableEditMode: T.func.isRequired,
  currentUser: T.object,
  measurementSystem: T.string.isRequired,
  countryCode: T.string,
};

export default connect(
  (state) => ({
    currentUser: state.auth.user,
    resources: state.dataTable.barnsheetsFarmTreatments.resources,
    isLoading: state.dataTable.barnsheetsFarmTreatments.isLoading,
    meta: state.dataTable.barnsheetsFarmTreatments.meta,
    reqParams: state.dataTable.barnsheetsFarmTreatments.params,
    measurementSystem: state.auth.user.current_company.measurement_system,
    countryCode: getCurrentCountryCode(state),
  }), (dispatch, { params }) => (
    {
      enableEditMode: (...args) => dispatch(enableEditMode(...args)),
      fetchData: (query) => dispatch(fetchData(`/farms/${params.farmId}/daily_checkup_treatment_products`,
        'barnsheetsFarmTreatments', query)),
    }
  )
)(BarnSheetsFarmTreatmentsHistory);
